export default "__VITE_PUBLIC_ASSET__4c121306__"